module.exports = __webpack_public_path__ + "img/AC8942_432D19_6E4D27_5F3B1C-256px.2ff7a6d8.png";